import { useSyncExternalStore } from 'react';
import type { BattleFeed, BattleView } from './battleFeed';

export function useBattle(feed: BattleFeed): BattleView | null {
  return useSyncExternalStore(
    (listener) => feed.subscribe(listener),
    () => feed.getSnapshot(),
    () => feed.getSnapshot(),
  );
}
